import { Icons } from '../icons';
import { BlurbLogoIcon } from '../icons/icon-def/BlurbLogoIcon';
import { testId } from '../utils';
import * as RadixToolbar from '@radix-ui/react-toolbar';
import clsx from 'clsx';
import React from 'react';

type ToolbarProps = {
  toggleSidebar: () => void;
  className?: string;
};

export const Toolbar: React.FC<ToolbarProps> = ({
  className,
  toggleSidebar,
}) => (
  <RadixToolbar.Root
    {...testId('toolbar')}
    className={clsx(
      'flex flex-0 w-full px-6 py-2 md:px-6 md:py-4 bg-white border-b border-gray-light',
      className,
    )}
  >
    <BlurbLogoIcon
      className="w-10 h-10 md:w-[52px] md:h-[49.961px]"
      {...testId('toolbar', 'logo')}
    />
    <div className="w-full flex justify-end">
      <RadixToolbar.Button
        onClick={toggleSidebar}
        className="md:hidden"
        {...testId('toolbar', 'menu-button')}
      >
        <Icons.Menu />
      </RadixToolbar.Button>
    </div>
  </RadixToolbar.Root>
);
